import { MatterStatementLayout } from './layouts';
import { MatterStatementHistoryView } from './components/MatterStatementHistoryView';

export function MatterStatementHistoryPage() {
  return (
    <MatterStatementLayout>
      <MatterStatementHistoryView />
    </MatterStatementLayout>
  );
}

